import { OnlineApplicationService } from "../services/online-application.service";
import * as i0 from "@angular/core";
import * as i1 from "../services/online-application.service";
export class LoginGuard {
    constructor(onlineApplicationServices) {
        this.onlineApplicationServices = onlineApplicationServices;
    }
    canActivate(route, state) {
        return this.onlineApplicationServices.isLoggedIn();
    }
}
LoginGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginGuard_Factory() { return new LoginGuard(i0.ɵɵinject(i1.OnlineApplicationService)); }, token: LoginGuard, providedIn: "root" });
